module.exports = __webpack_public_path__ + "assets/f82ac2ec399d15dd8e7841e8f7724e42.mp3";